module.exports = __webpack_public_path__ + "static/img/applicableScene4.6cbff03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene4.png
// module id = hxUI
// module chunks = 0